module.exports = __webpack_public_path__ + "img/button_toroku.95e20fe0.png";